import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiErr } from "../lib/api";

export default function XCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const denied = params.get("error");

    (async () => {
      if (denied || !code || !state) {
        toast.error("X connection was cancelled.");
        navigate("/inputs", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/x/callback", { code, state });
        toast.success(`X connected${data.username ? ` as @${data.username}` : ""} — bookmarks are now a source.`);
      } catch (e) {
        toast.error(apiErr(e.response?.data?.detail) || "Could not connect X.");
      } finally {
        window.history.replaceState(null, "", "/inputs");
        navigate("/inputs", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0A0D12] gap-4">
      <Loader2 className="w-8 h-8 text-emerald-400 animate-spin" />
      <p className="text-zinc-400 font-mono text-sm">Connecting your X account…</p>
    </div>
  );
}
